/**
 * Snapping method.
 * @link https://github.com/DjonnyX/rcx-virtual-list/tree/main/src/lib/src/enums/snapping-method.ts
 * @author Evgenii Grebennikov
 * @email djonnyx@gmail.com
 */
export var SnappingMethods;
(function (SnappingMethods) {
    /**
     * Normal group rendering.
     */
    SnappingMethods["NORMAL"] = "normal";
    /**
     * The group is rendered on a transparent background. List items below the group are not rendered.
     */
    SnappingMethods["ADVANCED"] = "advanced";
})(SnappingMethods || (SnappingMethods = {}));
